import LayoutHandler from './Esearcher/Layout/LayoutHandler';
import modern from './layouts/modern/multiple_dialog';
import modern2 from './layouts/modern/navigation';
import modern3 from './layouts/modern/dropdown';

LayoutHandler.on('modern', modern);
LayoutHandler.on('modern', modern2);
LayoutHandler.on('modern', modern3);
